module.exports = __webpack_public_path__ + "static/media/sad-kopila-walk.ea145bd0.png";